import { teacherMessagesEN } from './lib/intl/en-US';

export const programId = '5e9a09651ea9a81aa6cdca2c';

export const defaultOptions = {
    restApi: {
        serviceUrl: 'https://services.sheerid.com',
    },

    logLevel: 'error',
    useFingerprinting: true,
    messagesWithLocale: {
        'en-US': teacherMessagesEN,
    },
};
